import { HolderOutlined } from "@ant-design/icons"
import { useSortable } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"
import { Checkbox, Flex } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import { ActionTooltip } from "../ActionTooltip.tsx"

interface Props {
  id: string
  label: string
  visible: boolean
  onToggle: (next: boolean) => void
}

export const SortableColumnRow: React.FC<Props> = ({
  id,
  label,
  visible,
  onToggle
}) => {
  const { t } = useTranslation()
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({ id })

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.6 : 1,
    padding: 8,
    border: "1px solid var(--dk-border, #f0f0f0)",
    borderRadius: 4,
    marginBottom: 4,
    background: "var(--dk-surface, #fff)"
  }

  return (
    <div ref={setNodeRef} style={style}>
      <Flex align="center" gap={8}>
        <ActionTooltip title={t("entityTable.dragToReorder")}>
          <span
            {...attributes}
            {...listeners}
            style={{ cursor: "grab", display: "inline-flex" }}
            aria-label={t("entityTable.dragToReorder")}
          >
            <HolderOutlined />
          </span>
        </ActionTooltip>
        <Checkbox
          checked={visible}
          onChange={(e) => onToggle(e.target.checked)}
        >
          {label}
        </Checkbox>
      </Flex>
    </div>
  )
}
